import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect, useRequest } from 'hooks';

import Modal from 'components/Modal';
import { Button, Checkbox, Datepicker, Select } from 'components/Misc/Form';

import { useGradeStudentStore } from 'store/grade/useGradeStudentStore';
import { useGradeStudentsAssignStore } from 'store/grade/useGradeStudentsAssignStore';

const Assign = () => {
	// Cache current grade's id
	const { id } = useParams();

	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Use student store
	const [options, parameters] = useGradeStudentStore(state => [
		state.options,
		state.parameters
	]);

	// Use student assign store
	const [data, subjects, courses, onChange, onInitSubjects, onInitCourses] = useGradeStudentsAssignStore(state => [
		state.data,
		state.subjects,
		state.courses,
		state.onChange,
		state.onInitSubjects,
		state.onInitCourses
	]);

	// Store request parameters
	const params = useMemo(() => ({
		subjectId: data.subjectId
	}), [data.subjectId]);

	// Store collected subjects
	const [, collectSubjects] = useCollect('subjects', null, onInitSubjects);

	// Store collected courses
	const [, collectCourses] = useCollect('courses', params, onInitCourses);

	// Store request
	const [[progress], request] = useRequest('put', `grades/${id}`);

	// Handle modal's visibility toggle
	const onModal = () => setModal(prev => !prev);

	// Handle student submition
	const onSubmit = async () => {
		// Try to assign students to course
		const [success] = await request({
			...data,
			options
		}, {
			...parameters,
			related: 'students:courses'
		});

		// Reset on success
		if (success) onModal();
	};

	// Collect subjects on mount
	useEffect(() => {
		(async () => await collectSubjects())();
	}, [collectSubjects]);

	// Collect courses on subject selection
	useEffect(() => {
		if (params.subjectId) (async () => await collectCourses())();
	}, [params, collectCourses]);

	return (
		<>
			<Button
				theme="success"
				value="Pievienot moduli"
				onClick={onModal}
			/>

			<Modal title="Pievienot moduli" visible={modal} handleModal={onModal}>
				<div className="grid grid-cols-2 gap-4">
					<Select
						name="subjectId"
						label="Mācību kurss"
						placeholder=" "
						value={data.subjectId}
						onChange={onChange}
						options={subjects?.map(subject => ({
							value: subject.id,
							name: subject.title
						}))}
					/>

					<Select
						name="courseId"
						label="Mācību modulis"
						placeholder=" "
						disabled={!courses?.length}
						value={data.courseId}
						onChange={onChange}
						options={courses?.map(course => ({
							value: course.id,
							name: course.title
						}))}
					/>

					<Datepicker
						asInput
						name="startDate"
						label="Sākuma datums"
						value={data.startDate}
						onChange={onChange}
					/>

					<Datepicker
						end
						asInput
						name="endDate"
						label="Beigu datums"
						value={data.endDate}
						onChange={onChange}
					/>

					<Checkbox
						small
						name="additional"
						value={data.additional}
						onChange={onChange}
						label="Pievienot kā papildus moduli?"
					/>

					<div className="col-span-2 flex justify-end">
						<Button
							progress={progress}
							theme="success"
							value="Pievienot moduli"
							onClick={onSubmit}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default Assign;